import dateFns from 'date-fns/locale/it';

export default {
  dateFns,

  format: {
    date: 'd/M/yyyy',
    time: 'p',
    dateTime: '$t(format:date) $t(format:time)',
    longDate: 'd MMM',
    longDateTime: "d MMMM 'alle' p",
    fullDate: 'd MMM, y',
    fullDateTime: "d MMMM, y 'alle' p",
  },

  translation: {
    common: {
      account: 'Account',
      actions: 'Azioni',
      addAttachment_title: 'Aggiungi Allegato',
      addComment: 'Aggiungi commento',
      addManager_title: 'Aggiungi Manager',
      addMember_title: 'Aggiungi Membro',
      addUser_title: 'Aggiungi Utente',
      administrator: 'Amministratore',
      all: 'tutto',
      allChangesWillBeAutomaticallySavedAfterConnectionRestored:
        'Tutte le modifiche verranno salvate<br />al ripristino della connessione.',
      areYouSureYouWantToDeleteThisAttachment: 'Sei sicuro di voler eliminare questo allegato?',
      areYouSureYouWantToDeleteThisBoard: 'Sei sicuro di voler eliminare questa bacheca?',
      areYouSureYouWantToDeleteThisCard: 'Sei sicuro di voler eliminare questa card?',
      areYouSureYouWantToDeleteThisComment: 'Sei sicuro di voler eliminare questo commento?',
      areYouSureYouWantToDeleteThisLabel: 'Sei sicuro di voler eliminare questa etichetta?',
      areYouSureYouWantToDeleteThisList: 'Sei sicuro di voler eliminare questo elenco?',
      areYouSureYouWantToDeleteThisProject: 'Sei sicuro di voler eliminare questo progetto?',
      areYouSureYouWantToDeleteThisTask: 'Sei sicuro di voler eliminare questo task?',
      areYouSureYouWantToDeleteThisUser: 'Sei sicuro di voler eliminare questo utente?',
      areYouSureYouWantToLeaveBoard: 'Sei sicuro di voler abbandonare la bacheca?',
      areYouSureYouWantToLeaveProject: 'Sei sicuro di voler abbandonare il progetto?',
      areYouSureYouWantToRemoveThisManagerFromProject:
        'Sei sicuro di voler rimuovere questo amministratore dal progetto?',
      areYouSureYouWantToRemoveThisMemberFromBoard:
        'Sei sicuro di voler rimuovere questo membro dalla bacheca?',
      attachment: 'Allegato',
      attachments: 'Allegati',
      authentication: 'Autenticazione',
      background: 'Background',
      board: 'Bacheca',
      boardNotFound_title: 'Bacheca non trovata',
      canComment: 'Può commentare',
      canEditContentOfBoard: 'Può modificare il contenuto della bacheca.',
      canOnlyViewBoard: 'Può solo vedere la bacheca.',
      cardActions_title: 'Card Azioni',
      cardNotFound_title: 'Card non trovata',
      cardOrActionAreDeleted: "La card o l'azione vengono eliminate.",
      color: 'Colore',
      copy_inline: 'copia',
      createBoard_title: 'Crea Bacheca',
      createLabel_title: 'Crea Etichetta',
      createNewOneOrSelectExistingOne: 'Crea nuovo o seleziona<br />esistente.',
      createProject_title: 'Crea Progetto',
      createTextFile_title: 'Create File di Testo',
      currentPassword: 'Password corrente',
      dangerZone_title: 'Zona pericolosa',
      date: 'Data',
      dueDate: 'Data di scadenza',
      dueDate_title: 'Data di scadenza',
      deleteAttachment_title: 'Elimina Allegato',
      deleteBoard_title: 'Elimina Bacheca',
      deleteCard_title: 'Elimina card',
      deleteComment_title: 'Elimina Commento',
      deleteLabel_title: 'Elimina Etichetta',
      deleteList_title: 'Elimina Elenco',
      deleteProject_title: 'Elimina Progetto',
      deleteTask_title: 'Elimina Task',
      deleteUser_title: 'Elimina Utente',
      description: 'Descrizione',
      detectAutomatically: 'Rileva automaticamente',
      dropFileToUpload: 'Trascina il file da caricare',
      editor: 'Editor',
      editAttachment_title: 'Modifica Allegato',
      editAvatar_title: 'Modifica Avatar',
      editBoard_title: 'Modifica Board',
      editDueDate_title: 'Modifica Data di Scadenza',
      editEmail_title: 'Modifica E-mail',
      editInformation_title: 'Modifica Informazioni',
      editLabel_title: 'Modifica Etichetta',
      editPassword_title: 'Modifica Password',
      editPermissions_title: 'Modifica Permessi',
      editStopwatch_title: 'Modifica Timer',
      editUsername_title: 'Modifica Username',
      email: 'E-mail',
      emailAlreadyInUse: 'E-mail già in uso',
      enterCardTitle: 'Inserire titolo della card...',
      enterDescription: 'Inserire descrizione...',
      enterFilename: 'Inserire nome del file',
      enterListTitle: 'Inserire titolo della lista...',
      enterProjectTitle: 'Inserire titolo del progetto',
      enterTaskDescription: 'Inserire descrizione del task...',
      filterByLabels_title: 'Filtra per Etichetta',
      filterByMembers_title: 'Filtra per Membro',
      fromComputer_title: 'Dal Computer',
      fromTrello: 'Da Trello',
      general: 'Generale',
      hours: 'Ore',
      importBoard_title: 'Importa Board',
      invalidCurrentPassword: 'Password corrente non valida',
      labels: 'Etichette',
      language: 'Lingua',
      leaveBoard_title: 'Lascia Bacheca',
      leaveProject_title: 'Lascia Progetto',
      list: 'Lista',
      listActions_title: 'Lista delle Azioni',
      managers: 'Managers',
      members: 'Membri',
      minutes: 'Minuti',
      moveCard_title: 'Sposta card',
      name: 'Nome',
      newestFirst: 'Dal più recente',
      newEmail: 'Nuova e-mail',
      newPassword: 'Nuova password',
      newUsername: 'Nuovo username',
      noConnectionToServer: 'Nessuna connessione al server',
      noBoards: 'No bacheche',
      noLists: 'No liste',
      noProjects: 'No progetti',
      notifications: 'Notifiche',
      noUnreadNotifications: 'Nessuna notifica non letta.',
      oldestFirst: 'Dal meno recente',
      openBoard_title: 'Bacheca aperta',
      optional_inline: 'opzionale',
      organization: 'Organizazzione',
      phone: 'Telefono',
      preferences: 'Preferenze',
      pressPasteShortcutToAddAttachmentFromClipboard:
        'Consiglio: premi Ctrl-V (Cmd-V on Mac) per aggiungere un allegato dalla clipboard.',
      project: 'Progetto',
      projectNotFound_title: 'Progetto non trovato',
      removeManager_title: 'Rimuovi Manager',
      removeMember_title: 'Rimuovi Membro',
      searchLabels: 'Cerca etichette...',
      searchMembers: 'Cerca membri...',
      searchUsers: 'Cerca utenti...',
      searchCards: 'Cerca cards...',
      seconds: 'Secondi',
      selectBoard: 'Seleziona bacheca',
      selectList: 'Seleziona lista',
      selectPermissions_title: 'Seleziona Permessi',
      selectProject: 'Seleziona progetto',
      settings: 'Impostazioni',
      sortList_title: 'Ordina',
      stopwatch: 'Timer',
      subscribeToMyOwnCardsByDefault: 'Abbonati alle mie card per impostazione predefinita',
      taskActions_title: 'Task Azioni',
      tasks: 'Tasks',
      thereIsNoPreviewAvailableForThisAttachment:
        'Non è disponibile alcuna anteprima per questo allegato.',
      time: 'Tempo',
      title: 'Titolo',
      userActions_title: 'Azioni Utente',
      userAddedThisCardToList: '<0>{{user}}</0><1> ha aggiunto questa card a {{list}}</1>',
      userLeftNewCommentToCard:
        '{{user}} ha lasciato un nuovo commento «{{comment}}» a <2>{{card}}</2>',
      userMovedCardFromListToList: '{{user}} ha mosso <2>{{card}}</2> da {{fromList}} a {{toList}}',
      userMovedThisCardFromListToList:
        '<0>{{user}}</0><1> ha mosso questa card da {{fromList}} a {{toList}}</1>',
      username: 'Username',
      usernameAlreadyInUse: 'Username già in uso',
      users: 'Utenti',
      viewer: 'Viewer',
      writeComment: 'Scrivi un commento...',
    },

    action: {
      addAnotherCard: "Aggiungi un'altra card",
      addAnotherList: "Aggiungi un'altra lista",
      addAnotherTask: 'Aggiungi un altro task',
      addCard: 'Aggiungi card',
      addCard_title: 'Aggiungi Card',
      addComment: 'Aggiungi commento',
      addList: 'Aggiungi lista',
      addMember: 'Add membro',
      addMoreDetailedDescription: 'Aggiungi una descrizione più dettagliata',
      addTask: 'Aggiungi task',
      addToCard: 'Aggiungi alla card',
      addUser: 'Aggiungi utente',
      createBoard: 'Crea bacheca',
      createFile: 'Crea file',
      createLabel: 'Crea etichetta',
      createNewLabel: 'Crea nuova etichetta',
      createProject: 'Crea progetto',
      delete: 'Elimina',
      deleteAttachment: 'Elimina allegato',
      deleteAvatar: 'Elimina avatar',
      deleteBoard: 'Elimina bacheca',
      deleteCard: 'Elimina card',
      deleteCard_title: 'Elimina Card',
      deleteComment: 'Elimina commento',
      deleteImage: 'Elimina immagine',
      deleteLabel: 'Elimina etichetta',
      deleteList: 'Elimina lista',
      deleteList_title: 'Elimina Lista',
      deleteNotifications: 'Dismiss all',
      deleteProject: 'Elimina progetto',
      deleteProject_title: 'Elimina Progetto',
      deleteTask: 'Elimina task',
      deleteTask_title: 'Elimina Task',
      deleteUser: 'Elimina utente',
      duplicate: 'Duplica',
      duplicateCard_title: 'Duplica Card',
      edit: 'Modifica',
      editDueDate_title: 'Modifica data di scadenza',
      editDescription_title: 'Modifica Descrizione',
      editEmail_title: 'Modifica E-mail',
      editInformation_title: 'Modifca Informazioni',
      editPassword_title: 'Modifica Password',
      editPermissions: 'Modifica permessi',
      editStopwatch_title: 'Modifica Timer',
      editTitle_title: 'Modifica Titolo',
      editUsername_title: 'Modifica Username',
      hideDetails: 'Nascondi dettagli',
      import: 'Importa',
      leaveBoard: 'Lascia bacheca',
      leaveProject: 'Lascia progetto',
      logOut_title: 'Disconnettiti',
      makeCover_title: 'Crea Cover',
      move: 'Muovi',
      moveCard_title: 'Muovi Card',
      remove: 'Rimuovi',
      removeBackground: 'Rimuovi background',
      removeCover_title: 'Rimuovi Cover',
      removeFromBoard: 'Rimuovi dalla bacheca',
      removeFromProject: 'Rimuovi dal Progetto',
      removeManager: 'Rimuovi manager',
      removeMember: 'Rimuovi membro',
      save: 'Salva',
      showAllAttachments: 'Mostra tutti gli allegati ({{hidden}} hidden)',
      showDetails: 'Mostra dettagli',
      showFewerAttachments: 'Mostra meno allegati',
      sortList_title: 'Ordina',
      start: 'Inizio',
      stop: 'Ferma',
      subscribe: 'Iscriviti',
      unsubscribe: 'Annulla iscrizione',
      uploadNewAvatar: 'Carica nuovo avatar',
      uploadNewImage: 'Carica nuova immagine',
    },
  },
};
